import { StartBatchStep } from "components/Picklist/New/StartBatchStep";
import React from "react";
import { useLoaderData } from "react-router-dom";
import { FulfillmentBatch } from "hooks/useFulfillmentBatch";
import { AutoPagePaperLayout } from "pages/Layouts/AutoPagePaperLayout";
import { PageBreadcrumbs, PageSubtitle, PageTitle } from "pages/Layouts/components/PageTitleContainer";

export const StartBatchPage = () => {
  const { batch } = useLoaderData() as { batch: FulfillmentBatch };
  return (
    <AutoPagePaperLayout paperProps={{ sx: { padding: 3 } }}>
      <PageBreadcrumbs links={[{ label: "Fulfillment" }]} />
      <PageTitle>Picklist</PageTitle>
      <PageSubtitle>Fulfill e-commerce units for laptops in batches.</PageSubtitle>
      <StartBatchStep batch={batch} />
    </AutoPagePaperLayout>
  );
};
